import * as lottie from "lottie-web";

export function setupAnimation() {

    var animationContainers = document.getElementsByClassName("c-animation__wrapper");
    // console.log(animationContainers);

    if (animationContainers.length > 0) {
        for (let i = 0; i < animationContainers.length; i++) {
           
            var container = animationContainers[i];
            var playerDiv = container.querySelector(".c-animation__player");
            var animationSrc = playerDiv.getAttribute("data-animation");
            const scrollPositionTop = container.getBoundingClientRect().top - 150;
            // const scrollPositionBottom = container.getBoundingClientRect().top + 300;
            // console.log(scrollPositionTop);

            const playerRef = lottie.loadAnimation({
                container: playerDiv,
                path: animationSrc,
                autoplay: false,
                loop: false,
            });
            
            // if playerDiv has class 'c-animation__player--mobile-autoplay' and window width is less than 1024px
            if (playerDiv.classList.contains("c-animation__player--mobile-autoplay") && $(window).width() < 1200) {
                playerRef.autoplay = true;
            }

            // On mouse enter, play
            container.addEventListener(
                "mouseenter",
                function () {
                    if (playerRef.isPaused) {
                        playerRef.goToAndPlay(0);
                    }
                },
                false
            );

            if ($(window).width() < 1200) {
                window.addEventListener(
                    "scroll",
                    function () {
                        let scroll = this.scrollY;

                        if (scroll > scrollPositionTop) {
                            playerRef.play();
                        }
                    },
                    false
                );
            }
        }
    }

    // auto-play animation
    if (document.getElementsByClassName("c-animation__autoplayer")) {

        var animationContainers = document.getElementsByClassName("c-animation__autoplayer");

        for (let i = 0; i < animationContainers.length; i++) {
            var container = animationContainers[i];
            var animationSrc = container.getAttribute("data-animation");

            const playerRef = lottie.loadAnimation({
                container: container,
                path: animationSrc,
                autoplay: true,
                loop: true,
            });
        }
    }    
}

setupAnimation();